// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_AT_RULE_IMPORT_0___ from "-!../../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[5].use[1]!../../../node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[5].use[2]!../../index.css";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.validator_dashBoard_head {
    max-width: 1200px;
    margin: 0 auto;
    padding: 20px;
    background-color: var(--card-background-color);
    font-family: var(--app-font-family);
}

.validator_wallet_note {
    text-align: center;
    margin-bottom: 20px;
    color: var(--text-color);
    width: 100%;
    max-width: var(--dashboard-max-width);
    font-size: 1.75rem;
    font-weight: 400;
    border-bottom: 1px solid #e0e0e0;
    font-family: var(--app-font-family);
}

.validator_metrics_loader_card,
.validator_metrics_error_card {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    height: 100vh;
    color: var(--text-color);
    background-color: var(--background-color);
}

.all_validators_charts_main_grid {
    display: grid;
    gap: 1rem;
    width: 100%;
    height: auto;
    margin: 1rem 0;
    grid-template-rows: repeat(2, 1fr);
    padding: 0 1rem;
}

.all_validators_chart-container {
    width: 100%;
    height: 100%;
    min-height: 300px;
    background: var(--card-background-color);
    /* border: 1px solid var(--border-color); */
    border-radius: 8px;
    position: relative;
    /* box-shadow: 0 2px 4px rgba(0, 36, 117, 0.1); */
    /* Using primary color with opacity */
}

.chart-legend {
    position: absolute;
    top: 45px;
    left: 50%;
    transform: translateX(-50%);
    display: flex;
    justify-content: center;
    align-items: center;
    color: var(--text-color);
    z-index: 10;
    white-space: nowrap;
    font-size: 12px;
}

.data-source {
    text-align: right;
    color: #666;
    font-size: 12px;
    margin-top: 20px;
}

.pie_charts_container {
    display: grid;
    grid-template-columns: 64% 35%;
    gap: 1rem;
    width: 100%;
    margin: 1rem 0;
}

.pie_chart_left,
.pie_chart_right {
    background: var(--card-background-color);
    border-radius: 8px;
    /* padding: 1rem; */
    width: 100%;
}

/* Responsive design for mobile devices */
@media screen and (max-width: 768px) {
    .pie_charts_container {
        grid-template-columns: 1fr;
        gap: 1.5rem;
    }

    .pie_chart_left,
    .pie_chart_right {
        width: 100%;
    }
}

@media screen and (min-width: 1024px) {

    .all_validators_chart-container {
        height: 500px;
    }
}

@media screen and (max-width: 640px) {
    .all_validators_chart-container {
        height: 550px;
        padding: 0.5rem;
        margin-bottom: 1.5rem;
    }

    .chart-legend {
        font-size: 10px;
    }

    .all_validators_charts_main_grid {
        gap: 1.5rem;
        padding: 0 0.5rem;
    }
}`, "",{"version":3,"sources":["webpack://./src/styles/hype_staking/validator_table.css"],"names":[],"mappings":"AAEA;IACI,iBAAiB;IACjB,cAAc;IACd,aAAa;IACb,8CAA8C;IAC9C,mCAAmC;AACvC;;AAEA;IACI,kBAAkB;IAClB,mBAAmB;IACnB,wBAAwB;IACxB,WAAW;IACX,qCAAqC;IACrC,kBAAkB;IAClB,gBAAgB;IAChB,gCAAgC;IAChC,mCAAmC;AACvC;;AAEA;;IAEI,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,mBAAmB;IACnB,aAAa;IACb,wBAAwB;IACxB,yCAAyC;AAC7C;;AAEA;IACI,aAAa;IACb,SAAS;IACT,WAAW;IACX,YAAY;IACZ,cAAc;IACd,kCAAkC;IAClC,eAAe;AACnB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,iBAAiB;IACjB,wCAAwC;IACxC,2CAA2C;IAC3C,kBAAkB;IAClB,kBAAkB;IAClB,iDAAiD;IACjD,qCAAqC;AACzC;;AAEA;IACI,kBAAkB;IAClB,SAAS;IACT,SAAS;IACT,2BAA2B;IAC3B,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,wBAAwB;IACxB,WAAW;IACX,mBAAmB;IACnB,eAAe;AACnB;;AAEA;IACI,iBAAiB;IACjB,WAAW;IACX,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,SAAS;IACT,WAAW;IACX,cAAc;AAClB;;AAEA;;IAEI,wCAAwC;IACxC,kBAAkB;IAClB,mBAAmB;IACnB,WAAW;AACf;;AAEA,yCAAyC;AACzC;IACI;QACI,0BAA0B;QAC1B,WAAW;IACf;;IAEA;;QAEI,WAAW;IACf;AACJ;;AAEA;;IAEI;QACI,aAAa;IACjB;AACJ;;AAEA;IACI;QACI,aAAa;QACb,eAAe;QACf,qBAAqB;IACzB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,WAAW;QACX,iBAAiB;IACrB;AACJ","sourcesContent":["@import \"./../../index.css\";\n\n.validator_dashBoard_head {\n    max-width: 1200px;\n    margin: 0 auto;\n    padding: 20px;\n    background-color: var(--card-background-color);\n    font-family: var(--app-font-family);\n}\n\n.validator_wallet_note {\n    text-align: center;\n    margin-bottom: 20px;\n    color: var(--text-color);\n    width: 100%;\n    max-width: var(--dashboard-max-width);\n    font-size: 1.75rem;\n    font-weight: 400;\n    border-bottom: 1px solid #e0e0e0;\n    font-family: var(--app-font-family);\n}\n\n.validator_metrics_loader_card,\n.validator_metrics_error_card {\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    align-items: center;\n    height: 100vh;\n    color: var(--text-color);\n    background-color: var(--background-color);\n}\n\n.all_validators_charts_main_grid {\n    display: grid;\n    gap: 1rem;\n    width: 100%;\n    height: auto;\n    margin: 1rem 0;\n    grid-template-rows: repeat(2, 1fr);\n    padding: 0 1rem;\n}\n\n.all_validators_chart-container {\n    width: 100%;\n    height: 100%;\n    min-height: 300px;\n    background: var(--card-background-color);\n    /* border: 1px solid var(--border-color); */\n    border-radius: 8px;\n    position: relative;\n    /* box-shadow: 0 2px 4px rgba(0, 36, 117, 0.1); */\n    /* Using primary color with opacity */\n}\n\n.chart-legend {\n    position: absolute;\n    top: 45px;\n    left: 50%;\n    transform: translateX(-50%);\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    color: var(--text-color);\n    z-index: 10;\n    white-space: nowrap;\n    font-size: 12px;\n}\n\n.data-source {\n    text-align: right;\n    color: #666;\n    font-size: 12px;\n    margin-top: 20px;\n}\n\n.pie_charts_container {\n    display: grid;\n    grid-template-columns: 64% 35%;\n    gap: 1rem;\n    width: 100%;\n    margin: 1rem 0;\n}\n\n.pie_chart_left,\n.pie_chart_right {\n    background: var(--card-background-color);\n    border-radius: 8px;\n    /* padding: 1rem; */\n    width: 100%;\n}\n\n/* Responsive design for mobile devices */\n@media screen and (max-width: 768px) {\n    .pie_charts_container {\n        grid-template-columns: 1fr;\n        gap: 1.5rem;\n    }\n\n    .pie_chart_left,\n    .pie_chart_right {\n        width: 100%;\n    }\n}\n\n@media screen and (min-width: 1024px) {\n\n    .all_validators_chart-container {\n        height: 500px;\n    }\n}\n\n@media screen and (max-width: 640px) {\n    .all_validators_chart-container {\n        height: 550px;\n        padding: 0.5rem;\n        margin-bottom: 1.5rem;\n    }\n\n    .chart-legend {\n        font-size: 10px;\n    }\n\n    .all_validators_charts_main_grid {\n        gap: 1.5rem;\n        padding: 0 0.5rem;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
